<script setup>
import { ref, computed } from "vue";
import { useVuetify } from "../../Composables/useVuetify.js";
import { VDialog, VBottomSheet } from "vuetify/lib";
import { router } from "@inertiajs/vue2";

// Composables

const breakpoint = useVuetify().breakpoint;

// Emits

const emit = defineEmits(["submit"]);

// Props

const props = defineProps({
    title: {
        type: String,
        default: "Are you sure?",
        required: false,
    },
    subtitle: {
        type: String,
        default: "",
        required: false,
    },
    submit: {
        type: Object,
        required: true,
    },
});

// Reactive State

const show = ref(true);
const valid = ref(false);
const form = ref(null);
const loading = ref(false);

// Computed

const getComponent = computed(() => {
    return {
        component: breakpoint.xs ? VBottomSheet : VDialog,
        props: {
            "max-width": breakpoint.xs ? "inherit" : "380",
            "content-class": "desktop-scroll",
        },
    };
});

// Methods

function reset(success = false) {
    loading.value = false;
    show.value = false;
    setTimeout(() => {
        props.submit.close();
    }, 300);
    emit("reset", success);
}

function process() {
    if (loading.value) return;
    loading.value = true;
    if (!form.value.validate()) {
        loading.value = false;
        return;
    }

    router.visit(props.submit.url, {
        method: props.submit.method,
        data: props.submit.data,
        preserveState: true,
        preserveScroll: true,
        onSuccess: () => reset(true),
        onError: (errors) => {
            loading.value = false;
            console.log("Form returned errors" + JSON.stringify(errors));
        },
    });
}
</script>

<template>
    <component
        :is="getComponent.component"
        v-bind="{ ...getComponent.props }"
        v-model="show"
        :class="['soli-round']"
        content-class="soli-round"
        @click:outside="reset()"
    >
        <v-form ref="form" v-model="valid" @submit.prevent="process()">
            <v-card
                flat
                max-height="90vh"
                class="simple-form half-round safe-bottom overflow-auto soli-grey"
            >
                <v-btn
                    icon
                    color="dark"
                    class="modal-close-btn"
                    @click="reset()"
                    ><v-icon>clear</v-icon></v-btn
                >
                <v-container class="py-0">
                    <v-card-title>{{ title }}</v-card-title>
                    <v-card-subtitle class="pt-4">{{
                        subtitle
                    }}</v-card-subtitle>
                    <v-card-text>
                        <slot name="body"></slot>
                    </v-card-text>
                </v-container>
                <v-divider />
                <v-card-actions class="justify-end">
                    <v-btn text rounded color="dark" @click="reset()">
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        rounded
                        :disabled="!valid"
                        :loading="loading"
                        color="primary"
                        @click="process($event)"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </component>
</template>
